import React, { ReactElement } from "react";
import { Text } from "@kunduz/ui-atoms";
import { Star01 } from "@untitled-ui/icons-react";

export const UnstyledPackageTitle = (props: Props): ReactElement => {
  function isStarFilled(index: number) {
    if (!props.rating) return false;
    return index - 0.5 <= parseFloat(props.rating.replace(",", "."));
  }

  return (
    <div className={props.className} data-theme={props.theme}>
      {props.badgeText && <p data-role="badge">{props.badgeText}</p>}
      {props.title && <h1 data-role="title">{props.title}</h1>}
      <div
        data-role="row"
        style={{
          display: "flex",
          ...(!!props.onReviewsClicked && { cursor: "pointer" }),
        }}
        onClick={props.onReviewsClicked}
      >
        {props.rating !== undefined && (
          <div data-role="ratingWrapper">
            <div data-role="starWrapper">
              {Array.from(Array(5)).map((s, t) => (
                <Star01
                  key={`star_${t}`}
                  color="#FEC84B"
                  width={16}
                  height={16}
                  data-state={isStarFilled(t + 1) ? "filled" : undefined}
                />
              ))}
            </div>

            {props.rating}
          </div>
        )}
        <Text variant="textxs">•</Text>
        {props.reviewLabel && (
          <div data-role="reviewLabel">{props.reviewLabel}</div>
        )}
      </div>
    </div>
  );
};

interface Props {
  className?: string;
  badgeText?: string;
  title?: string;
  rating?: string;
  reviewLabel?: string;
  onReviewsClicked?: () => void;
  theme?: string;
}
